<div *ngIf="data">

    <div class="flex" style="justify-content: end;">
        <button mat-dialog-close="true" mat-icon-button>
            <mat-icon mat-dialog-close="true" color="warn">close</mat-icon>
        </button>
    </div>
    <section class="pad">
        <iframe [src]="cleanURL(data.url)"></iframe>
        <div style="height: fit-content;" mat-dialog-actions align="end">
            <i>if unable to view certificate, click here to view in new tab</i>
            <a [href]="cleanURL(data.url)" target="_blank" mat-button color="accent">View</a>
        </div>
    </section>

</div>

<div *ngIf="!data">
    <h1 matDialogTitle style="color: var(--primary-color);">Information</h1>
    
    <mat-dialog-content>
        Are you sure you want to retrigger this certificate
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="warn">Cancel</button>
        <button mat-flat-button color="accent" [mat-dialog-close]="true">Yes</button>
        
    </mat-dialog-actions>
</div>